<template>
  <div>
    <b-row>
      <b-col cols="12">
        <label class="d-flex p-2 py-3 cursor-pointer border rounded-lg mb-3">
          <b-form-checkbox
            v-model="modelValue.status"
            switch
            :value="true"
            :unchecked-value="false"
          />
          <div class="d-flex flex-column">
            <div class="h4 mb-0">Ativo</div>
            <p class="small mb-0">
              Ao desativar esta opção, o ciclo de pagamento ficará inativo e não
              será exibido na visualização deste plano.
            </p>
          </div>
        </label>
      </b-col>
      <b-col cols="12">
        <label
          class="active-plan-banner d-flex p-2 py-3 border rounded-lg mb-3 cursor-pointer"
        >
          <b-form-checkbox
            v-model="modelValue.is_default"
            switch
            :value="true"
            :unchecked-value="false"
          />
          <div class="d-flex flex-column">
            <div class="h4 mb-0">Ciclo padrão</div>
            <p class="small mb-0">
              Ao ativar esta opção, este ciclo de pagamento será definido como
              padrão e exibido em destaque na exibição deste plano.
            </p>
          </div>
        </label>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Periodicidade">
          <b-form-select
            v-model="modelValue.periodicidade"
            :options="periodicidadeOptions"
            :state="validateState('periodicidade')"
          />
          <b-form-invalid-feedback :state="validateState('periodicidade')">
            Este campo é obrigatório.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group label="Valor base">
          <NumberFormat
            v-model.number="modelValue.valor_base"
            placeholder="Valor base"
            :state="validateState('valor_base')"
          />
          <b-form-invalid-feedback :state="validateState('valor_base')">
            Este campo é obrigatório.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Parcelas no crédito">
          <NumberFormat
            v-model.number="modelValue.parcelas_credito"
            placeholder="Ex: 12"
            :decimals="0"
            :state="validateState('parcelas_credito')"
          />
          <b-form-invalid-feedback :state="validateState('parcelas_credito')">
            Este campo é obrigatório.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Desconto boleto (%)">
          <NumberFormat
            v-model.number="modelValue.desc_boleto"
            placeholder="Ex: 5,00"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Desconto PIX (%)">
          <NumberFormat
            v-model.number="modelValue.desc_pix"
            placeholder="Ex: 5,00"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Máximo de cobranças">
          <NumberFormat
            v-model.number="modelValue.max_payments"
            placeholder="Ex: 12"
            :decimals="0"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import NumberFormat from "@/components/Form/NumberFormat.vue";
import { modelValue } from "@/mixins/modelValue";
import { getEmptyPeriodicidade } from "@/modules/planos/Components/Form/getEmptyPeriodicidade";
import { safeArray, size } from "@/helpers/functions/ArrayHelpers";
import { getPeriodicidades } from "@/modules/planos/Components/Form/getPeriodicidades";

export default {
  mixins: [validationMixin, modelValue("value", "input")],
  components: { NumberFormat },
  props: {
    value: {
      type: Object,
      default: () => getEmptyPeriodicidade(),
    },
    activePeriodicities: {
      type: Array,
      default: () => [],
    },
  },
  validations: {
    value: {
      periodicidade: { required },
      valor_base: { required },
      parcelas_credito: { required },
    },
  },
  computed: {
    periodicidadeOptions() {
      const actived = safeArray(this.activePeriodicities);
      const allPeriodicities = getPeriodicidades();

      if (size(this.activePeriodicities) > 0) {
        return allPeriodicities
          .map((periodicity) => {
            periodicity.disabled = actived.includes(periodicity.value);

            return periodicity;
          })
          .sort((periodicityA, periodicityB) =>
            periodicityA.disabled ? 1 : periodicityB.disabled ? -1 : 0
          );
      }

      return allPeriodicities;
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.value.$touch();
      return !this.$v.value.$anyError;
    },
    save() {
      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
        return null;
      }

      return cloneDeep(this.modelValue);
    },
    reset() {
      this.modelValue = getEmptyPeriodicidade();
      this.$v.$reset();
    },
  },
  created() {},
};
</script>
<style scoped lang="scss">
.active-plan-banner {
  background-color: rgba(34, 83, 115, 0.05);
}
</style>
